import { render, staticRenderFns } from "./Yssq.vue?vue&type=template&id=4515f5a1&scoped=true&"
import script from "./Yssq.vue?vue&type=script&lang=js&"
export * from "./Yssq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515f5a1",
  null
  
)

export default component.exports